
import Google_PageView from "app/tracking/google/page_view"
import Google_Event from "app/tracking/google/event"
import GA4_Event from "app/tracking/google/google_analytics_4/event"
import PageInstance from "app/page_instance"

declare global {
  interface Window {
    dataLayer: object[] | null
  }
}

const trackSignUp = (): void => {
  Google_PageView.track([
    "/fake-path",
    "/apps/spacious-web-app",
    "/pages/all-pages",
    "/components/authentication",
    "/events/sign_up",
  ].join(""))
  window.dataLayer = (window.dataLayer || [])
  window.dataLayer.push({
    event: "app:authentication:authenticated",
  })
  Google_Event.track({
    category: "Authentication",
    action:   "Sign in / Sign up Success",
  })

  GA4_Event.track({
    event_name: "sign_up",
    options:    {
      page: PageInstance.currentPageNameForTracking(),
    },
  })
}

const trackSignIn = (): void => {
  Google_PageView.track([
    "/fake-path",
    "/apps/spacious-web-app",
    "/pages/all-pages",
    "/components/authentication",
    "/events/sign_in",
  ].join(""))
  window.dataLayer = (window.dataLayer || [])
  window.dataLayer.push({
    event: "app:authentication:authenticated",
  })
  Google_Event.track({
    category: "Authentication",
    action:   "Sign in / Sign up Success",
  })

  GA4_Event.track({
    event_name: "sign_in",
    options:    {
      page: PageInstance.currentPageNameForTracking(),
    },
  })
}

export {
  trackSignUp,
  trackSignIn,
}
